import type { RetentionSettingsPayload } from '@Application/Accounts/RetentionSettings/Actions/retentionSettingsFetched';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class RetentionSettingsView {
	readonly accountId: number;
	readonly accountName: string;
	readonly audioRetentionDays: number;
	readonly beneficiaryRetentionMonths: number;

	constructor(payload: RetentionSettingsPayload) {
		this.accountId = payload.id;
		this.accountName = payload.name;
		this.audioRetentionDays = payload.audioRetentionDays;
		this.beneficiaryRetentionMonths = payload.beneficiaryRetentionMonths;

		Object.freeze(this);
	}
}

export default RetentionSettingsView;
